import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useContentItemVisibilityPost = () => {
  const createContentItemVisibilityRequest = useCallback((payloadData) => {
    const url = `${MONOLITH_ORIGIN}/api/v3/visibility/content-item-visibility/`;
    const payload = payloadData;
    const requestConfig = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(url, requestConfig);
  }, []);
  return useRestMutation(createContentItemVisibilityRequest);
};

export default useContentItemVisibilityPost;
